// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "クライアントにジャンプのお知らせ",
  "1d484fee4a": "財務部、営業部、プロジェクト管理、ビジネスデータ、製品部、運営部、研究開発管理、リリース計画、カスタマーサービス部、行政部、調達部、アフターサービス管理",
  "a2c88dfb79": "最初のチームを作成する",
  "3cfdcc6086": "財務部、営業部、プロジェクト管理/305、人事行政/306、運営部、研究開発マネジメント、バージョン計画、カスタマーサービス管理/403、購買部、アフターサービス管理",
  "ac45ec2c05": "アカウントのログイン検証に失敗しました",
  "9aef9b8ccd": "現在ログインしているアカウントが異常です。再ログイン後に再試行してください",
  "728dd00f22": "この携帯番号の検証に異常があります。SMS認証コードでログインしてみてください。",
  "30dbecd916": "ご入力情報に不適切な単語が含まれています。修正して再試行してください。",
  "12ed508d8a": "操作が頻繁すぎので、しばらくしてから再試行してください",
  "952d4a7595": "現在のアカウントのログイン状態が異常です。アカウントに再ログインしてから試してください。",
  "e64bfdeaa4": "ログイン確認に失敗しました。再度SMS確認を取得してください",
  "79008a65f1": "この携帯番号は複数の企業に既に参加しています。企業アカウントでログインするか、携帯番号を変更してください",
  "bf242eff42": "企業名が既に存在しています",
  "4f0cdb8374": "完全な電話番号を入力してください。海外の電話番号を使用している場合は、国内の番号 (86+) に変更してください",
  "46e79ffeff": "企業の作成に異常があります、公式のカスタマーサービスに連絡して解決してください",
  "f3e18f0341": "パラメータの認証に失敗",
  "503fd1718d": "SMS認証コードの送信に失敗",
  "24b3129f19": "送信が頻繁すぎので、しばらくしてから再試行してください",
  "1cde3e8245": "認証コードが間違っています。もう一度入力してください",
  "4212ecc031": "認証が何度も間違って、一時的に制限されます。しばらくしてから再試行してください",
  "735da9c347": "企業名の重複チェックに異常が発生しました。公式カスタマーサービスにご連絡して解決してください",
  "8731da9615": "企業名認証の検証に異常が発生しました。公式のカスタマーサービスに連絡してください",
  "62e89b3f16": "サービス契約に同意する",
  "c9b79027e5": "認証コードを送信",
  "84c1447b9d": "コピーが成功しました",
  "fba4b0abd0": "ホストレコード",
  "37f5a7cd41": "TXT値",
  "78b12427c9": "認証中...",
  "59d089837c": "現在、お客様のドメインを認証できません。ホスティングサービスプロバイダーが情報を更新するまでしばらくお待ちいただく必要があります。時間が経っても反応がない場合は、もう一度認証を試みるか、ドメインを変更してください。",
  "4a5b7383d1": "ドメイン名の検証記録をチェックしています",
  "f24a492e40": "このページを閉じて、しばらくして戻ってチェックすることができます。",
  "c697ca5f1a": "企業版へようこそ",
  "ebb01b1740": "次へ",
  "30109bf753": "お客様の企業はドメインを持っていますか？",
  "2b3e485b47": "私は企業のドメイン名を持っています",
  "1a7f5eae44": "企業ドメインを持っていません",
  "bde15d6d84": "企業アカウントを作成するためには、ドメイン名（例：example.com）が必要です。",
  "07ffb22c90": "申し訳ありませんが、企業アカウントを作成するにはドメイン名が必要です",
  "de23836563": "企業アカウントの作成に使用するドメインを入力してください",
  "287c07944a": "あなたのドメイン名を認証します",
  "3ea2d528d5": "以下の手順を完了すると、あなたが <b>{domain}</b> の所有者であることが証明でき、また誰もこのドメイン名を使用して企業アカウントに登録することができません。",
  "082b18ce56": "a. <b>新しいラベルページ</b>でドメインホスティングサービスプロバイダーのウェブサイトを開き、<b>ログイン</b>してください",
  "4f7e0841a9": "b. ドメイン・ホスティング・プロバイダーのウェブサイトで、<b>DNSレコードセクション</b>に進みます。ドメイン・ホスティング・プロバイダーのウェブページによっては、DNSレコードセクションの名前が異なる場合があります。例えば、<b>DNS Management（DNS管理）、Name Server Management（ドメインネームサーバー管理）、Control Panel（コントロールパネル）またはAdvanced Setting（高度な設定）と表示される場合があります。</b>",
  "6365ad6e3a": "次に、<b> ここに戻り </b>、「次へ」をクリックして認証レコードを追加してください。",
  "8528892080": "認証履歴を追加",
  "7a225304f8": "a. DNSページで、<b>TXT </b>までスクロールし、履歴を追加するために関連ボタンをクリックします；",
  "b3cb7d947c": "b. 下のすべての値 <b>をコピーして貼り付けて </b>ドメイン・ホスティング・プロバイダーのウェブサイトの<b>TXTフォーム </b>に；",
  "47213583bf": "c.ドメイン・ホスティング・プロバイダーのウェブサイトに記録を <b>保存し </b>、<br>その後 <b>ここに戻り </b>、下にある「ドメイン認証」をクリックしてください",
  "21486a57cf": "注意：名前／ホスト／エイリアスフィールドには「@」を入力するか、空白にしておくことができます。ドメインホスティングプロバイダは、このフィールドにドメイン名（<あなたのドメイン>.com）を入力することも要求するかもしれません。他のDNSレコードを参照して、このフィールドの記入方法を判断できるかもしれません。TTLのフィールドでは、「86400」を入力するか、デフォルト値を保持します。",
  "f1b8edab9c": "ドメインの変更",
  "7c6fc663a8": "ドメイン名認証",
  "b6aee9dc0d": "ドメインの認証に成功しました",
  "dd4cc429ea": "あなたが証明されました",
  "450f5c9230": "のオーナーであり、他の誰もこのドメインを使用して企業アカウントを登録することを禁止します。",
  "71cbcba755": "「次へ」をクリックし、企業アカウントの作成を完了しましょう。",
  "f4084f4870": "ログインアカウントを設定してください",
  "fe3138baec": "作成しました",
  "0315cddedb": "企業の作成に成功しました",
  "91454a7f34": "今すぐログインして、企業のメンバーのために企業アカウントを作成しましょう",
  "366304cde7": "1. 現在ログインしているWPSアカウントから自動的にログアウトされます",
  "8a9f2a8422": "管理者コントロールパネルにログインするためには、企業アカウント{account}@{domain}を使用する必要があります",
  "43e265e998": "管理コンソールにログインする",
  "9240efaaf0": "SMSが送信されました",
  "e424bb9a6d": "入力してください",
  "d44d581706": "企業名",
  "aa8679f406": "、4〜30文字",
  "581bdb1f98": "、特殊文字\\/:*?\"<>|を含めることはできません",
  "c13cabb67a": "メールアドレス",
  "2b9b429e46": "あなたのメール",
  "5ed834a7df": "メールアドレスを入力してください",
  "acfd1f02ed": "正しいメールアドレスを入力してください",
  "31c7c92cca": "、最大80桁",
  "3f27cf84b3": "確認コードを入力してください",
  "a0ae1f3ec4": "認証コードが正しくありません",
  "e5589c5e74": "お名前",
  "69d7bd63f6": "、漢字、英字、数字のみ入力可能",
  "91f008d258": "、最大8文字",
  "6ea6c9b39b": "連絡先の携帯番号",
  "161042c5b7": "携帯番号を入力してください",
  "e6b8eab1cd": "電話番号を入力してください、11桁の数字",
  "3fd5fbb3cc": "ドメイン名を入力してください",
  "cb5346ba8e": "正しい企業ドメイン名を入力してください。4〜30文字",
  "27928eb7a4": "アカウント",
  "8e19bd444d": "ログイン用のアカウント名を入力してください",
  "7bbbf479dc": "4-20桁、数字、字母、またはアンダースコアのみ",
  "3d84cae479": "要件に合致するアカウントを入力してください。最初の文字は英数字である必要があります",
  "c0d5ece1a7": "パスワード",
  "f444036fa8": "パスワードを入力してください",
  "b03218d72b": "パスワードは12-16桁の英大・小文字、数字または記号の3種類の組み合わせです",
  "b4ab05df50": "貴社のドメインは既にある方によって企業アカウントで使用されています。このドメインの所有権を持っていることを証明するため、カスタマーサービス（400-677-5005）にご連絡ください。 ",
  "c58876008f": "コピーに失敗、再試行してください",
  "86f73420de": "招待リンク",
  "a58861962c": "申し訳ありませんが、現在のブラウザーではこのQRコードのダウンロードがサポートされていません",
  "228db07f78": "財務部、営業部、プロジェクト管理、ビジネスデータ、製品部、運営部、研究開発管理、リリース計画、カスタマーサービス部、行政部、調達部、アフターサービス管理",
  "93896d7e98": "チームを作成した後、同僚と協力して作業を始めましょう",
  "e8f66fb75c": "財務部、営業部、プロジェクト管理/305、人事行政/306、運営部、研究開発マネジメント、バージョン計画、カスタマーサービス管理/403、購買部、アフターサービス管理",
  "831b73da9b": "名前には不正な文字や特殊記号/\\;:*?\"<>|%&を含むことはできません",
  "51ab33b3ee": "パラメータが正しくありません",
  "a297f9e951": "企業名が重複しています",
  "04d60ed5f5": "禁止ワードは使用できません",
  "2ff7bef083": "ドメインの形式が間違っています",
  "41e1ba2165": "ドメインのTXT情報の検証に失敗しました",
  "50f348caa9": "アカウントもうログインしました",
  "9d4c950d65": "この名前は既に登録されています",
  "38cf19ed95": "この組織名は既に存在します",
  "4b426e7c9c": "機関名",
  "298f880e18": "存在しています。より多い情報を補充することをお勧めします：",
  "1e67dd20b3": "組織名を復元",
  "517107cb04": "別の名前を使用する",
  "5667081882": "この名前で作成する",
  "e306a979a6": "クイック入力：",
  "f583db96e0": "*もし組織名が使用されている場合、",
  "9767148e34": "企業または組織名を入力してください。4〜100文字",
  "e0e0ec159f": "組織名",
  "5b13d254c0": "企業名は既に存在します",
  "92027671ec": "企業名",
  "36d482a7fb": "企業名を取り戻す",
  "79058a7577": "*会社名が使用されている場合、",
  "c96dd48dba": "企業名",
  "842efad336": "*企業の従業員である場合は、",
  "860f9bd77b": "カスタマーサービスに連絡する",
  "5a7ed18daf": "企業に加入する",
  "ab470e9ace": "連絡先情報を備える",
  "0a7e0e48a7": "申請した企業名：",
  "a8dc318dcc": "記入された連絡情報を確認してください。後ほどプラットフォームのカスタマーサービスからお電話があります",
  "6ea1f4d7f5": "資料を提出する",
  "d439e39f43": "あなたの情報を受け取りました",
  "884653426b": "カスタマーサービスは24時間以内にお電話しますので、応答にご注意ください！",
  "2361cb14bf": "WeChatでQRコードをスキャンしてオンラインカスタマーサービスに接続し、進捗を確認",
  "50f45d0031": "保存に失敗しました",
  "fc856d0fd2": "スーパーアドミン",
  "e16c0676d2": "管理者",
  "b1d2ddd126": "一般メンバー",
  "9d322cc08d": "機関名には特殊文字を含めることはできません\\/:*?\"<>|{}",
  "b583ba7363": "企業名には特殊な記号を含めることはできません\\/:*?\"<>|{}",
  "1d118a9bad": "機関名は最低4文字です。4〜100文字の機関名を入力してください。",
  "441b45b1f5": "企業名は最低4文字です。4〜100文字の企業名を入力してください",
  "97457cb1f0": "機関名が100文字を超えています。4〜100文字の機関名を入力してください",
  "8ce00d3b92": "企業名が100文字を超えています。4〜100文字の企業名を入力してください",
  "a72778d3de": "名前は最低2文字必要です。2～10文字の名前を入力してください",
  "79c17db5de": "名前が10文字を超えています。2~10文字で入力してください",
  "482a118202": "名前は漢字、数字、英字、・のみサポートしています",
  "9a9be18941": "チェックしてください",
  "e6b7c4aa66": "オンラインサービス契約",
  "595023d905": "組織を作成する",
  "ba8c2df551": "企業を作成する",
  "d284384975": "オンラインサービス契約",
  "5c266d5a84": "プライバシーポリシー",
  "fcb92dbcf6": "クラウドオフィスサービス契約",
  "2ae7a8a3f7": "WPS 365クラウドオフィスサービスを選んでいただきありがとうございます。以下は、主にあなたが代表する組織がKingsoft Officeと共に締結した登録、購読、そしてこのサービスの利用に関する法律契約紹介します。",
  "d30a6983bd": "{0} | {1} | {2}をお読みください。「同意」をクリックすると、この契約の内容に同意し、弊社のサービスを受け入れるものとみなされます。",
  "263e306ede": "以下の内容を確認し、同意しました{0} | {1} | {2}",
  "440129c0f1": "{0}を入力してください",
  "8ab916983d": "企業名",
  "b01d68543b": "お名前",
  "684b30d4e9": "あなたの携帯番号",
  "a48427e8e2": "企業専用のワークプラットフォームを構築するために使用します",
  "3a81b0f1fc": "同僚がシステム内であなたを見つけやすく、協力作業を進めることができます",
  "52bc539b6e": "作成を確認する",
  "b2fe245e19": "企業/チーム作成: ファイル共有と協力: ファイル共有と協力",
  "893282d3f7": "企業情報を追加してください：",
  "cc997bf6aa": "確認",
  "50fdde51ac": "{0}、{1}〜{2}位",
  "a19cc5ec18": "{0}，企業名には特殊な記号を含めることはできません\\/:*?\"<>|{}",
  "26857f28f9": "{0}、漢字、アルファベット、数字のみ入力できます",
  "f4080b1431": "{0}、最大{1}桁",
  "88e59b2d58": "{0}、11桁の数字",
  "91d6d4e105": "確認コードを入力してください",
  "bec71bde96": "認証コードが正しくありません",
  "e20ff8ee19": "{0}は必須です",
  "8dc09d10d7": "dwIdが見つかりません",
  "a03766ce6c": "学校",
  "03542addfe": "企業",
  "adb8a815d1": "携帯番号の連携{0}は上限に達しました",
  "97a6b66f1d": "携帯番号は既に連携されています{0}",
  "665e465487": "{0}を作成できません。現在の携帯番号 \"${1}\" がバインドされた{0}の数が最大限に達しています（最大5つの{2}まで可能）。以下の既にバインドされた{3}に入ることができます：",
  "a85b1367ca": "現在の携帯番号「{0}」は{1}に既に連携されています。既存の{2}でログインするか、新しい{3}を作成できます",
  "bf992ce17b": "別の携帯番号を使用して{0}を作成する",
  "395ea04444": "新規{0}を作成",
  "4ce3bb86b3": "追加した{0}の数が制限を超えています",
  "df88c4b7a5": "携帯番号 \"{0}\" が{1}に連携する数が上限に達しています",
  "78f7dd59ca": "現在の携帯電話番号“{0}”が以下の{1}と連携すると、直接に切り替えて使用できます",
  "8db491a3f8": "新しい{0}を作成し続ける",
  "83f6d9e1e4": "もう一度",
  "1dc5f11612": "または",
  "217d76f53e": "問題のフィードバック",
  "b69a6ea62a": "マウスの左ボタンを押しながら、2枚のシールドを削り取ってください",
  "3a31f64800": "おめでとうございます。盾を獲得しました<br/>次のステップに進んでください",
  "6a81fcee96": "読み込み中",
  "e97877a65d": "おっと、盾牌が見つからない<br/>ので、",
  "8d85456145": "長い間待っていました<br/>お願いします",
  "77ad847b95": "ネットワークが遅い<br/>",
  "dbd1ae3a34": "スクラッチが速すぎます<br/>お願いします",
  "bd8e05cd53": "ボタンをクリックして、スマート認証を開始します",
  "63d2a8a722": "認証しました",
  "73141928ad": "認証に失敗しました。ボタンをクリックして更新してください",
  "04856c5c8a": "スマート検出中",
  "52cd9bd26d": "操作が授権されていません",
  "fd157e8ea8": "ガイドを作成",
  "c6225c5b2b": "企業版へようこそ",
  "e33423fb1e": "作成しました",
  "7b0c035999": "WPS Docs企業作成成功ページ",
  "85db8faae0": "企業版の使用説明",
  "20591b9b44": "企業名を取り戻す",
  "b023d76dc2": "メンバーアップロードガイド",
  "e2f454e095": "{0}の企業",
  "df466f942b": "支部",
  "26a7b797c4": "サブセンター",
  "5fc82b360b": "ワンストップオフィスサービスプラットフォームで、オフィスがより効率的になる",
  "f2e736d52e": "企業版へようこそ",
  "becc41a35b": "企業名",
  "74685cdc58": "企業または組織名を入力してください。4〜100文字",
  "07b55b1907": "企業の規模",
  "77b2f763ad": "企業の規模を選択してください",
  "49d2509109": "5人以下",
  "8db2c9b74a": "6-20人",
  "a9fb0cf14a": "21-50人",
  "0fed41f8d3": "51-100人",
  "fb33f25a04": "101-200人",
  "3e3ff0f52e": "201-500人",
  "cd8b51f634": "501-2000人",
  "0662fa6eec": "2000人以上",
  "69334dba1a": "企業のニーズ",
  "79994e749c": "（私たちは企業に最適な業界実践ソリューションをお勧めします）",
  "840a017f38": "最も解決したい問題を選択してください",
  "f045b05c73": "あなたが設立した企業のニーズを入力してください",
  "d8efb0b36d": "その他",
  "adcb8fbb0c": "よく使う携帯番号",
  "eb1c73e2ca": "よく使う11桁の携帯番号を入力してください",
  "7f276e7dfa": "無料で作成",
  "c391b3eec1": "SMSの送信に失敗",
  "54f4cb8fa7": "SMSが送信されました",
  "231eb1fa1e": "企業ユーザー_{0}",
  "272b0f9d32": "企業ユーザー",
  "b209a67331": "企業の作成に失敗しました。リフレッシュしてください。",
  "acb08d0cc9": "企業の作成ステップ3",
  "83db361f51": "作成完了後、ジャンプロジックがトリガーされます",
  "1e930326e3": "次のステップに進む",
  "184df5c725": "フォーム保存失敗",
  "736eab3023": "検証を提出",
  "2db62dc13c": "検証に失敗しました",
  "54fb0afaea": "検証成功",
  "d39cff3fcf": "極端な保存をスキップした後、認証コードが必要であることに気づきました",
  "305b777ae5": "檢查名稱失敗開啟\"企業名稱被佔用\"彈窗及存儲名稱",
  "e57b6686b2": "認証主体が既に認証されたかを確認し、認証保護のプロンプトウィンドウをオンにします&対応する認証主題情報を保存します",
  "f7c86f496d": "作成した名前が重複 || 認証コードが期限切れ　承認されていない場合には、実行をブロックします",
  "cb37db4fd4": "handleSubmitが失敗しました",
  "243a569fc4": "その名前は既に登録されています。他の名前を使用してください。",
  "196851a3d9": "企業ユーザー_{0}",
  "0c3a3595ff": "企業ユーザー",
  "a33b41e0f2": "企業の作成に失敗しました。リフレッシュしてください。",
  "fcce6a7156": "作成しました",
  "5ec6da58a6": "クライアントに通知",
  "259c9dfa4e": "プロ版ロジック",
  "864156930f": "VBAロジック",
  "7824efd172": "WPS Docsモバイル版",
  "52b6cfaaaf": "WPSクライアント",
  "c7c51beea9": "教育版",
  "8d054d4986": "デフォルトポート",
  "b597e18fb1": "isWps365PcClientでopenurlがある",
  "b0c13de2a0": "isWps365PcClientまたは非client、openurlがあります",
  "7d0f2ce18c": "isWps365PcClientまたは非client、openurl successのコールバックがあります",
  "e2c5a07df6": "非client 非openurl",
  "29e0414d1f": "非クライアントで非openurlのコールバック",
  "60861f7d2a": "ビジネス側に autoChange の切り替えを任せる",
  "7c83140d90": "ゲスト状態が作成されました。SDKでアカウントを切り替える必要はありません（SDKはゲストをサポートしません）。codeはインターフェースで切り替わりました",
  "3379b09e59": "openurlがあり、hrefで切り替える",
  "586ff04c22": "個別にジャンプ",
  "b6c91f218b": "useSuccessSkip失敗",
  "47d2f3ba66": "その他",
  "57551f86ce": "utm_source に基づいて、異なるジャンプ方法をトリガーします",
  "64fe3758e2": "操作が授権されていません",
  "4da3e1262f": "作成しました。ビジネスオフィスの旅を始めましょう",
  "c38dfb8c6c": "最初のチームを作成する",
  "38dddb483b": "企業に入る",
  "614d9c91eb": "メンバーを招待する",
  "97f1eca0aa": "企業に入る",
  "13a4939e90": "企業の加入を招待",
  "a319e4ae0a": "同僚を招待する",
  "12e4da6bba": "同僚をすぐに招待する",
  "bd885380f6": "招待リンクの取得に失敗",
  "5e626c4063": "SMSが送信されました",
  "3dc09e7cfd": "ご申請の取り戻す企業名の数は既に上限に達しました",
  "48318f41f9": "メンバーを招待する",
  "45441baac4": "「{0}」に参加を招待します\tCX",
  "e5847fbd67": "リンクをコピーしてメンバーを招待する",
  "23101dd40a": "あなたのためにカスタマイズされたソリューションを作成中",
  "71bb7e54a8": "プロジェクト管理",
  "aff37c79cc": "選択したプランを体験する",
  "a97b174258": "他に<color: red>2</>名の同僚を招待して参加すると,、以下の企業特典を無料で得られます",
  "253855849f": "招待リンクをワークグループに共有して同僚を招待",
  "57b0a2a63f": "リンクをコピーして同僚を招待する",
  "71c0a37ee1": "企業に入る",
  "f848c60e0e": "他に<color:red>2</>名の同僚を招待して参加すると,、以下の企業特典を無料で得られます",
  "664e32b4fe": "招待ページ　企業に入る",
  "872f14403a": "同僚を招待する",
  "1880e7deb9": "同僚をすぐに招待する",
  "cc2a9aaf82": "作成しました",
  "02a13e2583": "他に$<color:red>2</>名の同僚を招待して参加すると,、以下の企業特典を無料で得られます",
  "5d3593cdce": "チーム情報の取得に失敗しました",
  "c025113ea1": "招待リンクの取得に失敗",
  "b83bc1e485": "リンクで招待",
  "0996ced9f6": "申し訳ありませんが、現在のブラウザーではこのQRコードのダウンロードがサポートされていません",
  "1e88451e31": "招待リンクがコピーされました",
  "bb969cabcd": "コピーに失敗、再試行してください",
  "15e1f79c7a": "企業に参加申請",
  "59c22b4ef8": "招待リンクを受け取りました",
  "0f0b392e60": "最初のチームを作成する",
  "0437d07c43": "企業名",
  "41800c7bf1": "作成者の名前を入力してください",
  "1ec5999511": "作成者の名前は最大8文字です",
  "02da35b4e4": "作成者の名前は漢字、アルファベット、数字のみ入力可能です",
  "184e9f6616": "携帯番号を入力してください",
  "9b587898ba": "正しい形式の携帯番号を入力してください",
  "e68c164a02": "メールアドレスを入力してください",
  "0b1de22df7": "正しい形式のメールアドレスを入力してください",
  "61026181ab": "営業許可証は必須です",
  "c3847e604e": "ファイルサイズが10Mを超えています。再選択してください",
  "49450f4ec7": "名前が重複した場合は申告書に記入する必要があります",
  "39c3b8fa1d": "提出に失敗しました",
  "3ea44d7963": "アップロード成功",
  "5b1aa3c2c4": "アップロードに失敗しました",
  "7e7f81eaa3": "アップロードに失敗しました、ファイルサイズが10MBを超えています",
  "2ff1913de1": "アップロードに失敗、ファイルは.jpg、.jpeg、.png、.bmp、.pdfである必要があります",
  "7951a879f2": "営業許可証は必須です",
  "66bda65057": "ファイルサイズが10Mを超えています。再選択してください",
  "8f2305a83d": "名前が重複した場合は申告書に記入する必要があります",
  "55ff0c8c6e": "提出に失敗しました",
  "8dad6d950d": "招待情報の取得に失敗しました",
  "a5f0ac3a9a": "作成しました",
  "4f1d069770": "招待ページのutmパラメータは{0}とname {1}です",
  "f9578cfe6d": "2ステップガイドアクセスのutmパラメータは{0}とname {1}",
  "e10d028405": "2ステップガイド pcoffice created",
  "8e22e4fcc4": "招待リンクがコピーされました",
  "3f327f9f37": "コピーに失敗、再試行してください",
  "bd1aecb265": "キャンセル",
  "b6abf9b19a": "同意する",
  "e910d9cc0f": "キャンセル",
  "37ab25522d": "同意する",
  "196b3eb9cf": "QRコードをスキャンして参加する",
  "2b81c52e20": "画像をダウンロードする",
  "62152fd9f3": "リンクで招待",
  "e0a3725651": "申し訳ありませんが、現在のブラウザーではこのQRコードのダウンロードがサポートされていません",
  "8b7883b2c7": "QRコードをスキャンして参加する",
  "9e9a659ed5": "画像をダウンロードする",
  "0d55065a9a": "リンクで招待",
  "487cf6a106": "申し訳ありませんが、現在のブラウザーではこのQRコードのダウンロードがサポートされていません",
  "78fd005d1f": "携帯番号を入力してください",
  "f909563857": "この番号を使用して作成する",
  "a26a19f139": "作成をキャンセル",
  "cc004ac9ee": "携帯番号",
  "4df8c3c588": "別の携帯番号を入力して学校を作成",
  "3151cabb3d": "別の携帯番号を入力して企業を作成",
  "56098a71eb": "スマート認証をクリックして、認証コードを送信します",
  "e96ec218e4": "SMS認証コードを入力してください",
  "ce619a0225": "SMS 認証コードを送信先",
  "0e9863aaeb": "認証コードが間違っています。もう一度入力してください",
  "32dc8629e1": "秒後に再送信",
  "e4eda9add5": "再送信",
  "b007977564": "承認情報の取得に失敗しました",
  "d8852ffc9c": "非管理者アクセス",
  "8a733a2574": "モバイル端末でアクセス",
  "9e8c152c4f": "PC端末アクセス",
  "2265a55e93": "サービス契約に同意する",
  "80dabe5aa3": "ガイドを作成",
  "7deee8bf5a": "二ステップガイド docsWeb created",
  "69eb501ecb": "あなたの申し立ては無効となり、アクセスできません。",
  "aa1d9d98ad": "アクセス権が不足しているため、アクセスできません",
  "fdf2fe129e": "組織を作成する",
  "7f0ca0df6b": "企業を作成する",
  "cc6ac2a93c": "2ステップガイドBase mounted",
  "5d6c570bf0": "2つのステップでbeforeunloadをガイドする",
  "a4eb8a192d": "みんなが作成しているチーム",
  "4912e16a9d": "企業名が見つかりました",
  "41c4e87ef2": "リンクをクリックして",
  "5e630930c0": "企業を再作成する",
  "436a563524": "既に企業を作成した場合、参照することができます。",
  "0b6e7cbe7f": "『企業名の変更方法』",
  "cb7bce0775": "チュートリアルで企業名を変更する",
  "3feadd3040": "現在のバージョンが古すぎるため、企業が使用できません",
  "3cf23de936": "ソフトウェアのバージョンが古いため、企業機能が使用できません。アプリストアでソフトウェアのバージョンを更新してください！",
  "a1c5d5d202": "了解しました",
  "e50183bd00": "WPSクラウドドキュメント",
  "e5031ab679": "安全、同步、協力",
  "c870026dfc": "WeChatでログイン",
  "e7647cd875": "携帯またはメールアドレス",
  "07b380074b": "QQログイン",
  "67921724dd": "その他の方法",
  "254da8a9f5": "参加/作成できる企業の数が上限に達しています。",
  "3648e4811b": "WPS Docsに入る",
  "dcd102b346": "カスタムチームを作成する",
  "8b9b258cbf": "チーム名を入力してください",
  "19bb6e0ded": "WPSメンバー特典、",
  "2d9fe8d938": "オフィス特権を利用して、日常のドキュメントの問題を解決し、体験してみましょう！",
  "e8c1caa649": "ローカルからアップロード",
  "03641083a3": "「個人ドキュメント」から移動",
  "eecd3ab9b5": "次回にします",
  "13b447b3a8": "替える",
  "3c2fc507fc": "現在のバージョンが古すぎるため、企業が使用できません",
  "c3615d8134": "ソフトウェアのバージョンが低すぎるため、企業機能を使用できません。公式ウェブサイトにアクセスしてソフトウェアを更新してください！",
  "644a36e05b": "アップデートする",
  "d435105f21": "参加/作成できる企業の数が上限に達しています。",
  "73a286ceb0": "金山ドキュメントのホームページに入る",
  "c2cec645c0": "キャンセル",
  "b5f5b83c0f": "同意する",
  "76ec352da5": "QRコードをスキャンして同僚を招待する",
  "6a509e4487": "QRコードをダウンロード",
  "940cc4a546": "企業を作成できません",
  "78b2a62ea5": "既存の企業に参加するか、新しい企業を作成します",
  "3a6da7f6f9": "現在の携帯番号が企業に連携された数が上限に達しました（最大5つの企業まで連携可能）",
  "93bab52870": "現在の携帯番号は企業に連携されていますので、既存の企業でログインできます:",
  "ce6e0adaf2": "以下の既にバインドされた企業から選択できます:",
  "1ce200a92b": "選択",
  "bb91ef2999": "新しい企業を作成する",
  "024e4a91e5": "企業名は既に登録されています",
  "eb089a23a0": "その企業名はすでに登録されています：",
  "7646558701": "管理者：",
  "1d9c02bd33": "登録日：",
  "919fc7805f": "上記の同僚を探して連絡を取ることをお勧めします。",
  "0ca71a9344": "あなたは一時的に他の名称を使って企業を作成してから（後で名称を変更することができます）、再度申し立てを提出することができます。",
  "e83a244e90": "クリックして申し立て方法を確認してください",
  "d22bedfb21": "確　定",
  "907b78b6e5": "ワークグループまたはチーム名を入力してください",
  "7195b0ac1e": "あなたが作成したいチーム",
  "60ed4f915e": "次へ",
  "f5ba8dfb7b": "ガイドをスキップ",
  "5c44a3ef68": "最大100文字",
  "130c53fb20": "名前には無効な文字や特殊記号を含めることはできません:/\\;:*?\"<>|%&",
  "e832d41acc": "2ステップガイドをスキップ",
  "80d9cf7177": "2ステップガイド リフレッシュ",
  "0aebf80435": "2つのステップでラベルをクリック",
  "e74f515977": "二つのステップのガイド",
  "308d2a53c9": "2ステップガイド グループ作成",
  "dda2ed7e18": "2つのステップガイド　チームの作成に失敗しました",
  "ded3c35500": "チームの作成に失敗しました",
  "4f18031bc1": "二段階ガイド createTemplate",
  "091e5cefcc": "2つのステップガイド createTemplateエラー",
  "58cf4e00f0": "認証コード",
  "92abbf0385": "認証コードを送信",
  "f0f9976ef9": "携帯番号を入力してください",
  "a4ce99b1df": "認証コード",
  "39d36e0f9f": "確認",
  "0fd8a01938": "送信",
  "9048a4e842": "携帯番号",
  "9afa1091eb": "再送",
  "58d787001f": "別の携帯番号を入力して学校を作成",
  "450905a265": "別の携帯番号を入力して企業を作成",
  "f7386de3c6": "ドロップダウンして選択",
  "27aa05a92c": "サービス契約に同意する",
  "80af61cb57": "前のページに戻る",
  "50149b8d4f": "申請人の氏名",
  "e6756f8749": "お名前を入力してください",
  "3cbd51a2b1": "名前は最低2文字必要です。2～10文字の名前を入力してください",
  "4f79b4813f": "名前は漢字、数字、英字、・のみサポートしています",
  "71d3e75983": "よく使う携帯番号",
  "afe5149035": "よく使う携帯番号を入力してください",
  "1e9270b50f": "常用する携帯番号を入力してください。11桁の数字です",
  "ff5dc98dfb": "スキップ",
  "165be2ab43": "前のステップに戻る",
  "231d8a335a": "サービス契約に同意する",
  "1cad008ffc": "企業名「{0}」は既に登録されています。別の名前を使用してください",
  "c6e274fcab": "契約確認",
  "b9352504bb": "協議ポップアップを閉じる",
  "8409e99ad0": "プロトコルポップアップを開く",
  "1593c6dd95": "提出",
  "4f44a9de22": "SMS認証を有効にする",
  "26b70c68b8": "スキップして企業に直接入る",
  "a8bebcb302": "前のページに戻る",
  "c800b4fec5": "招待ページベースマウント",
  "38b396d5b0": "招待ページ docsWeb Mounted",
  "2eb7f9a9f1": "あなたの申し立ては既に提出されました",
  "2c6f3590fb": "処理結果は3労働日以内にメールに送信する予定です",
  "2ea3eff708": "、ご確認ください。",
  "53acfba22c": "同僚をすぐに招待する",
  "4e6d282f4f": "企業の加入を招待",
  "5f72f4b936": "同僚をすぐに招待する",
  "e5383077ba": "企業名を取り戻す",
  "06e3fa2350": "クエリ結果によると、",
  "653a263b5e": "の作成者は",
  "769f57269f": "作成者の携帯番号",
  "09a224695e": "この企業の作成者が同僚であるか確認してください",
  "3beda6c149": "もし同僚であれば、連絡が取れます",
  "5c74dd10d1": "企業名の変更またはスーパー管理者の譲渡。",
  "da504edb0f": "·もし同僚でなければ、以下のボタンをクリックして企業名の復元を続けることができます",
  "39194faaf1": "企業名の取り戻す",
  "e22b829e90": "コピーが成功しました",
  "6e1b44752a": "TXT値",
  "79881b1d7a": "同僚をすぐに招待する",
  "a5344a45f9": "右上角をクリックし、【友達に送る】を選択してください",
  "a4954a5b08": "同僚をすぐに招待する",
  "8e3a1625fb": "企業名を取り戻す",
  "bf8b8c7005": "企業の営業許可証をアップロード",
  "bfd44a66c9": "クリックして選択",
  "d503f20925": "企業の営業許可証のスキャンまたは写真をアップロードしてください",
  "cbebe043c5": "JPG、JPEG、PNG、BMP、PDF形式にサポートしています。サイズは10 MBを超えないでください。",
  "9650b96d7d": "重複名申し立て情報表をアップデート",
  "c3b8ae46d3": "同名申し立て情報表のスキャン画像または写真をアップロードしてください。",
  "9e325a9e09": "情報テンプレートをダウンロードする",
  "a4711aae88": "申請を提出する",
  "3a5cc1441e": "認証中...",
  "0bd7bf8511": "現在、お客様のドメインを認証できません。ホスティングサービスプロバイダーが情報を更新するまでしばらくお待ちいただく必要があります。時間が経っても反応がない場合は、もう一度認証を試みるか、ドメインを変更してください。",
  "fae48d554b": "ドメイン名の検証記録をチェックしています",
  "5e1779a0ca": "このページを閉じて、しばらくして戻ってチェックすることができます。",
  "ca85f8b836": "企業版へようこそ",
  "2570e0f00b": "ログインに失敗しました",
  "40d16a007e": "はあなたの個人アカウントに自動的に連携されました。",
  "81376b92e4": "{0}ログイン方法です。ログインし直して企業アカウントに切り替えてください。",
  "ba679ba739": "了解しました、ログインする",
  "c05f64c6c6": "{0}後で自動的にログインに移動します",
  "c329ccef3a": "ログインに失敗しました",
  "e370f9afb1": "はあなたの個人アカウントに自動的に連携されました。",
  "410cf42585": "ログイン方法です。ログインし直して企業アカウントに切り替えてください。",
  "062d48aece": "了解しました、ログインする",
  "95a105d412": "後で自動的にログインに移動します",
  "2d000d5a6d": "メンバーに共有リンクを送信し、メンバーが開いた後参加を申請できます",
  "8861b6e90d": "企業に入る",
  "25b9f72fda": "ページのパラメーターが正しくない",
  "1c76123efc": "招待リンクの取得に失敗",
  "6caba48b76": "スキップ",
  "f66379c650": "ページのパラメーターが正しくない",
  "c45021de2a": "作成に失敗しました",
  "011d470126": "プラットフォームがお客様の情報セキュリティを継続的に保護しています",
  "f1a44d9151": "プラットフォームは国際BSIによってISO27001、ISO27701の認証を受け、国家三級の安全資格評価に合格しました--",
  "255ea5dff7": "セキュリティホワイトペーパー",
  "bb55b124f2": "企業プレゼンテーションの作成",
  "61e24974a3": "企業を作成して策略を取得",
  "bfdf78febe": "次に情報を入力してください",
  "c4aa2d2d60": "グループまたはプロジェクト名を入力してください",
  "b69765ab64": "みんなが作成しているチーム",
  "9657d9408b": "替える",
  "e21da8c16a": "次へ",
  "224ef5cc9f": "ガイドをスキップ",
  "641f58c8f6": "現在の企業ではメンバーのチーム作成はサポートされていません。管理者に作成を依頼してください",
  "efea622752": "リンクをコピーして同僚を招待する",
  "fd5b40a9fd": "「{0}」に参加するように招待されています。協力して仕事をしよう",
  "b04dd2f10a": "招待リンクがコピーされました",
  "d1606a1b1a": "コピーに失敗、再試行してください",
  "0d59f3db83": "「営業部」などのプロジェクト部門またはチームを入力してください",
  "9429513d34": "ガイドは必要ありません",
  "b54a20b1ff": "作成に失敗しました",
  "093fa0fb74": "ログイン承認中…",
  "b383b136f4": "企業を作成するプロジェクトの初期化",
  "b6b21b388b": "企業名は既に登録されています",
  "285dc68c10": "その企業名はすでに登録されています：",
  "1bf685b89d": "管理者：",
  "7b4297edcc": "登録日：",
  "fa51ea19fc": "上記の同僚を探して連絡を取ることをお勧めします。",
  "e3678a996d": "あなたは一時的に他の名称を使って企業を作成してから（後で名称を変更することができます）、再度申し立てを提出することができます。",
  "5969bc8071": "了解しました",
  "ba4cf699df": "企業名を取り戻す",
  "afecee4eb4": "お名前",
  "a8bdebc614": "お名前を入力してください",
  "5bbeb38a66": "連絡先の携帯番号",
  "b4f7b44b7a": "お携帯番号を入力してください",
  "cac2913686": "連絡先メールアドレス",
  "23d3bb3a42": "連絡先のメールアドレスを入力してください",
  "ea106a393c": "企業の営業許可証をアップロード",
  "f74131d71e": "クリックして選択",
  "53749c51c5": "企業の営業許可証のスキャンまたは写真をアップロードしてください",
  "c00f2ea171": "JPG、JPEG、PNG、BMP、PDF形式にサポートしています。サイズは10 MBを超えないでください。",
  "57ec07fa97": "重複名申し立て情報表をアップデート",
  "8eb0606e94": "同名申し立て情報表のスキャン画像または写真をアップロードしてください。",
  "f59e76c0b0": "情報テンプレートをダウンロードする",
  "030bd26fa4": "申請を提出する",
  "0a602dc727": "データの安全な保存",
  "9138f28acf": "ファイルの共有と共同編集",
  "b3a306cf90": "正規ライセンス",
  "973c53f725": "名前を変更してください。登録後に機関認証を申請し、名前を更新できます。",
  "f886f5e92f": "名前を変更してください。登録後に企業認証を申請し、名前を更新できます。",
  "b8051702a3": "この名前には不適切な言葉が含まれる可能性があります。名前の調整またはカスタマーサービスへのご連絡をお願いいたします。",
  "d73881f7d4": "企業名は保護されています",
  "dc7e58e320": "この企業名は保護されています。使用する前に主体認証が必要です。企業名の変更をおすすめします。あるいは、登録後に企業認証を行ってからご使用ください。",
  "20c3bc070c": "確認",
  "c4278e5f28": "権限が不足しています",
  "9217efae21": "お使いのアカウントには作成権限がありません。営業担当者にお問い合わせください。",
  "52ff08f2ad": "機関名は保護されていますので、企業名を調整してください",
  "79386ae280": "6桁の認証コードを入力してください",
  "d7b2c5a41b": "認証コードが送信されました。送信先は",
  "ce2e1c26f7": "(10分以内有効)",
  "59d338903f": "{0}秒後にもう一度認証コードを送信できます",
  "5aadd14136": "認証コードを再取得",
  "90f5c93432": "この名前はすでに使用われています",
  "1677072f4a": "追加情報を入力するか、他の名前を使用してください",
  "3b8459fb1e": "クイック入力：",
  "6f38edbcb1": "この名前で登録",
  "8406c81e2d": "支店",
  "29d323fa85": "サブセンター",
  "4f0e806e02": "財務部",
  "3f935efb6b": "サービス規約に同意する",
  "b42241be05": "後で",
  "99de4b33b7": "同意する",
  "7f867e7395": "別の電話番号で企業を作成",
  "0d51a8f7a6": "作成を続ける",
  "8bdaecf2e5": "携帯電話番号を入力してください",
  "565ae60c8a": "お名前を入力してください",
  "f76e06d0e7": "携帯電話番号を入力してください",
  "7b0fca5255": "認証コードを入力してください",
  "68026d2d25": "企業版へようこそ",
  "d25b5541be": "無料で作成",
  "32cfd73733": "チーム、企業、または組織名を入力してください",
  "4cf83dc4a0": "1分で簡単に作成し、共同作業の効率が上がります",
  "d320d37116": "チーム/企業を無料で作成",
  "c54b475dd2": "利用規約",
  "190d54e616": "{0}の企業",
  "8c1b768ac4": "スマート検証に失敗しました",
  "d74eab0f35": "企業名の入力情報がプラットフォームの規定に準拠していません。修正して再試行してください",
  "0f3d62dd4f": "お名前の入力情報がプラットフォームの規定に準拠していません。修正して再試行してください",
  "647cf2211b": "現在の携帯番号では作成できません。携帯番号を変更してください",
  "b63d96cdae": "入力情報がプラットフォームの規定に準拠していません。修正して再試行してください",
  "2dbbe8e43f": "現在の携帯番号では作成できません。携帯番号を変更してください",
  "b18abc5de6": "未登録の携帯番号",
  "f5233dae6f": "携帯番号を変更して作成してください",
  "4167c8b88d": "現在の携帯番号には以下のような状況がある可能性があります。携帯番号を変更して作成してください。ご不明な点があれば、カスタマーサポートにお問い合わせください",
  "a8a2433c4d": "WeChatでスキャンして追加し、カスタマーサポートにお問い合わせください",
  "444a639c09": "了解しました",
  "69a097057f": "現在の携帯番号は<#BB2726>仮想運営業者の番号帯<#BB2726>に属しています",
  "4370b06fd0": "現在の携帯番号に<#BB2726>異常な使用行動<#BB2726>があります",
  "8c49e1dc4a": "人間と機械の検証が必要です"
}